import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { energySourceService } from "@/services/energy-source/energySourceService";

export const useEnergySourceActions = () => {
    const { toast } = useToast();
    const { t } = useLanguage();
    const { user } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    const handleDelete = async (id: string) => {
        try {
            setIsLoading(true);
            await energySourceService.delete(id, user?.uid);
            toast({
                title: t("success"),
                description: t("energySources.deleted"),
            });
        } catch (error) {
            console.error("Error deleting energy source:", error);
            toast({
                title: t("error"),
                description: t("energySources.deleteError"),
                variant: "destructive",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return {
        handleDelete,
        isLoading,
    };
}; 